module.exports = __webpack_public_path__ + "static/media/backk.a514c7c0.png";